import { textVariant } from './Text'
import { TagComposition } from '@codeleap/web'
import { createStyles } from '@codeleap/styles'
import { StyleRegistry } from '../styles'

const createTagVariant = createStyles<TagComposition>

export const TagStyles = {
  default: createTagVariant(theme => {
    const DEFAULT_HEIGHT = 32
    const backgroundColor = theme.baseColors.primarySolid100
    const color = theme.baseColors.neutralSolid800
    const iconSize = theme.values.iconSize[2]

    return {
      wrapper: {
        width: 'fit-content',
        height: DEFAULT_HEIGHT,
        padding: theme.spacing.value(1),
        borderRadius: theme.radius.small,
        backgroundColor,
        ...theme.presets.alignCenter,
        ...theme.presets.justifyCenter,
        ...theme.presets.row,
      },
      'wrapper:disabled': {
        cursor: 'not-allowed',
      },
      leftWrapper: {
        ...theme.presets.alignCenter,
        ...theme.presets.justifyCenter,
        ...theme.presets.row,
        marginRight: theme.spacing.value(0.5),
      },
      rightWrapper: {
        ...theme.presets.alignCenter,
        ...theme.presets.justifyCenter,
        ...theme.presets.row,
        marginLeft: theme.spacing.value(0.5),
      },
      text: {
        color,
        ...textVariant('p3'),
        lineHeight: 16,
        marginVertical: 'auto',
      },
      leftIcon: {
        color,
        height: iconSize,
        width: iconSize,
        marginRight: theme.spacing.value(0.5),
      },
      rightIcon: {
        color,
        height: iconSize,
        width: iconSize,
        marginLeft: theme.spacing.value(0.5),
      },
      rightBadgeWrapper: {
        ...theme.presets.relative,
        marginLeft: theme.spacing.value(0.5),
      },
      leftBadgeWrapper: {
        ...theme.presets.relative,
        marginRight: theme.spacing.value(0.5),
      },
    }
  }),
  neutral: createTagVariant(theme => {
    const backgroundColor = theme.baseColors.neutralSolid200
    const color = theme.baseColors.neutralSolid800

    return {
      wrapper: { backgroundColor },
      text: { color },
      leftIcon: { color },
      rightIcon: { color },
    }
  }),
  destructive: createTagVariant(theme => {
    const backgroundColor = theme.baseColors.redSolid100
    return { wrapper: { backgroundColor } }
  }),
  'border:small': createTagVariant(theme => ({
    wrapper: { borderRadius: theme.radius.regular },
  })),
  'border:medium': createTagVariant(theme => ({
    wrapper: { borderRadius: theme.radius.large },
  })),
  small: createTagVariant(theme => ({
    wrapper: {
      borderRadius: theme.radius.infinite,
      ...theme.spacing.px(1.5),
    },
  })),
  neutralSecondary: createTagVariant(theme => ({
    wrapper: {
      backgroundColor: 'rgba(244, 244, 244, 1)',
    },
    text: {
      color: 'rgba(50, 57, 64, 1)',
    },
  })),
  highlightPrimary: createTagVariant(theme => ({
    wrapper: {
      backgroundColor: 'rgba(0, 24, 242, 1)',
    },
    text: {
      color: 'rgba(255, 255, 255, 1)',
    },
  })),
}

StyleRegistry.registerVariants('Tag', TagStyles)
